import { SeminarContentType } from '@/services/seminars';
import * as Styles from './SeminarSpeaker.styles';

export type SeminarSpeakerProps = Pick<SeminarContentType, 'speaker'>;

const SeminarSpeaker = ({ speaker }: SeminarSpeakerProps): JSX.Element => {
  return (
    <div>
      <Styles.DescriptionSubTitle data-testid="seminar-details-speaker">
        Speaker
      </Styles.DescriptionSubTitle>
      <div>
        <Styles.Author>
          <Styles.AuthorImage
            data-testid="seminar-details-speaker-image"
            src={speaker.picture}
            alt=""
          />
          <div>
            <Styles.AuthorName data-testid="seminar-details-speaker-name">
              {speaker.name}
            </Styles.AuthorName>
            <Styles.AuthorJobTitle data-testid="seminar-details-speaker-job-title">
              {speaker.jobTitle} {!!speaker?.companyName && `at ${speaker.companyName}`}
            </Styles.AuthorJobTitle>
          </div>
        </Styles.Author>
        <Styles.DescriptionText data-testid="seminar-details-speaker-about">
          {speaker.about}
        </Styles.DescriptionText>
      </div>
    </div>
  );
};

export default SeminarSpeaker;
